import { provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter, withComponentInputBinding, withRouterConfig, withViewTransitions } from '@angular/router';
import { AppComponent } from '@cbo/app/app.component';
import { routes } from '@cbo/app/app.routing';
import { httpErrorsInterceptor, timezoneInterceptor } from '@cbo/app/core/http';
import { localizationConfig } from '@td/i18n';
import { provideNgxMask } from 'ngx-mask';
import { googleMapsInitializer, httpHostInterceptor, withEnvironment } from '@td/core';
import { environment } from '@cbo/environments/environment';
import { provideHoneybadger } from '@td/errors';
import { provideAuth } from './app/core/services';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { provideTransloco } from '@jsverse/transloco';

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { floatLabel: 'auto', appearance: 'outline' },
    },
    withEnvironment(environment),
    provideAuth(),
    provideNgxMask(),
    provideHttpClient(
      withInterceptors([
        httpHostInterceptor,
        timezoneInterceptor,
        httpErrorsInterceptor,
        includeBearerTokenInterceptor,
      ]),
    ),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withRouterConfig({ paramsInheritanceStrategy: 'always' }),
      withViewTransitions(),
    ),
    provideHoneybadger(),
    googleMapsInitializer(),
    provideTransloco(localizationConfig),
  ],
}).catch((err) => console.error(err));
